module.exports = __webpack_public_path__ + "media/images/logo-797b0699c6172bc6976e88342322f9ff.png";